import React from "react";
import Textfield from "Components/UI/Form/Textfield";
import dayjs from "dayjs";

import Grid from "@mui/material/Grid";

import InvoicesCombobox from "Components/Invoice/InvoicesCombobox";
import EndcustomerArticlesCombobox from "Components/Article/EndcustomerArticlesCombobox";
import EndcustomersComboBox from "Components/Endcustomer/EndcustomersComboBox";
import PriceField from "Components/UI/Form/PriceField";
import DateWithClear from "Components/UI/Form/DateWithClear";

export default function EndcustomerAccountForm({
  formData,
  invoices,
  endcustomers,
  endcustomerArticles,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield disabled label="ID" value={formData.Id} type="number" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="Amount"
            onChange={(newVal) => handleInputChange("Amount", newVal)}
            label="Belopp"
            value={formData.Amount}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <EndcustomersComboBox
            label={"SlutkundsID"}
            endcustomers={endcustomers}
            selectedEndcustomerID={
              formData.EndCustomerId ? formData.EndCustomerId : null
            }
            onChange={(newVal) => handleInputChange("EndCustomerId", newVal)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <EndcustomerArticlesCombobox
            label={"Slutkundartikel ID"}
            endcustomerArticles={endcustomerArticles}
            selectedArticleID={
              formData.EndCustomerArticleId
                ? formData.EndCustomerArticleId
                : null
            }
            onChange={(newVal) => {
              handleInputChange("EndCustomerArticleId", newVal);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <InvoicesCombobox
            label={"Faktura ID"}
            selectedInvoiceID={formData.InvoiceId ? formData.InvoiceId : null}
            onChange={(newVal) => handleInputChange("InvoiceId", newVal)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Utskriven ref"
            value={formData.PrintedId}
            type="number"
            onChange={(e) => handleInputChange("PrintedId", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Bokförings ref"
            value={formData.BookRefId}
            type="number"
            onChange={(e) => handleInputChange("BookRefId", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Betalnings ref"
            value={formData.PaymentId}
            type="number"
            onChange={(e) => handleInputChange("PaymentId", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Utskrift ref"
            value={formData.ConnectedPrintId}
            type="number"
            onChange={(e) =>
              handleInputChange("ConnectedPrintId", e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Kredit"
            value={formData.FromAccount}
            type="string"
            onChange={(e) => handleInputChange("FromAccount", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Debet"
            value={formData.ToAccount}
            type="string"
            onChange={(e) => handleInputChange("ToAccount", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="Bokföringsdatum"
            value={dayjs(formData.BookingDate)}
            onChange={(value) => handleInputChange("BookingDate", value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Beskrivning"
            value={formData.Description}
            type="string"
            onChange={(e) => handleInputChange("Description", e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );
}
